import { Link } from "@tanstack/react-router";

export const PROVIDER_MISSION_ANCHOR = "mission";

export function renderProviderAboutLink(providerId: string, hash?: string) {
    return (props: { className: string; children: string }) => (
        <Link
            to="/provider/$providerId/about"
            params={{ providerId }}
            hash={hash}
            {...props}
        />
    );
}
